import type { ReactNode } from "react";

export type StatusTone = "ok" | "info" | "bad";

const TONE_STYLES: Record<StatusTone, { bar: string; icon: string; symbol: string }> = {
  ok: { bar: "border-rs-green/35 bg-rs-green/10", icon: "bg-rs-green", symbol: "✓" },
  info: { bar: "border-[#3c4235] bg-rs-jet", icon: "bg-[#a9b0a1]", symbol: "i" },
  bad: { bar: "border-rs-red/45 bg-rs-red/12", icon: "bg-rs-red", symbol: "!" },
};

interface Props {
  tone: StatusTone;
  detail?: string;
  children: ReactNode;
}

export function UploadStatusBar({ tone, detail, children }: Props) {
  const toneStyle = TONE_STYLES[tone];
  return (
    <div
      className={`flex items-start gap-2.5 rounded-md border px-3.25 py-2.5 text-[13px] text-rs-off-white ${toneStyle.bar}`}
      role="status"
    >
      <span
        className={`grid place-items-center size-4.5 flex-none rounded-full text-[11px] font-bold text-rs-black ${toneStyle.icon}`}
        aria-hidden="true"
      >
        {toneStyle.symbol}
      </span>
      <div className="flex-1 min-w-0">
        {children}
        {detail && <span className="block mt-0.5 text-[12.5px] text-[#a9b0a1]">{detail}</span>}
      </div>
    </div>
  );
}
